import support from '../support';
class driverManager {
    constructor() {
        this.uploadDrivers = {};
        this.middlewares = {};
        this.firmwareDrivers = {};
        for (let key in support.drivers) {
            this.uploadDrivers[key] = support.drivers[key];
        }
        for (let key in support.upload.middlewares) {
            this.middlewares[key] = support.upload.middlewares[key];
        }
        for (let key in support.firmware) {
            this.firmwareDrivers[key] = support.firmware[key];
        }
    }
    addUploadDriver(name, driver) {
        this.uploadDrivers[name] = driver;
    }
    getUploadDriver(name) {
        return this.uploadDrivers[name];
    }
    addFirmwareDriver(name, driver) {
        this.firmwareDrivers[name] = driver;
    }
    getFirmwareDriver(name) {
        return this.firmwareDrivers[name];
    }
    addMiddleware(name, middleware) {
        this.middlewares[name] = middleware;
    }
    getMiddleware(name) {
        return this.middlewares[name];
    }
}
let inst = new driverManager();
export default inst;
